import { httpClient } from '../../services/http-client'
import { Organization } from '../../models/organization'

class OrganizationApi {

    getAll() {
        return httpClient.get(`/organization/`)
            .then(res => {
                return res.data as Organization[]
            })
    }

    createOrganization(userId: number, orgName: string) {
        return httpClient
            .post(`/organization/createUserOrg?userId=${userId}`, {
                name: orgName
            })
            .then(res => {
                return { orgId: res.data.organizationId, token: res.data.token }
            })
    }

    renameOrganization(userId: number, org: Organization) {
        return httpClient
            .post(`/organization/renameOrg?userId=${userId}`, org)
    }

    updateClassification(org: Organization) {
        return httpClient
            .post(`/organization/updateClassification`, org)
    }

    removeOrganization(orgId: number) {
        return httpClient
            .delete(`/organization/${orgId}`)
    }

    switchOrganization(orgId: number) {
        return httpClient
            .get(`/organization/switch?orgId=${orgId}`)
            .then(res => {
                return res.data as string
            })
    }

    userOrganizations(userId: number) {
        return httpClient
            .get(`/organization/userOrgs?userId=${userId}`)
            .then(res => {
                return res.data as Organization[]
            })
    }
}

export const orgApi = new OrganizationApi()
